<div class="people-details-container">
    <nb-card>
        <div fxFlex="100" fxLayout="column" fxLayoutGap="20px">
            <div style="padding: 10px; background-color: #23DCE1; border-radius: 5px 5px 0 0;" fxFlex="20" fxLayout="row"
                fxLayoutAlign="space-between start">
                <div class="sub-heading-blue-16">SEARCH RESULTS</div>
                <div style="cursor: pointer;"><img src="assets/icons/closeicon.png" (click)="closeDialog()" alt="img"></div>
            </div>
            <div fxFlex="80" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px" style="padding: 0 10px;">
                <div class="profile-container">
                    <img style="border-radius: 70px;" height="110" width="110" [src]="getProfileImageSrc(peopleImage)"
                        alt="profile_img" loading="lazy">
                </div>
                <div fxLayout="column" fxLayoutAlign="space-between start" fxLayoutGap="7px">
                    <div class="sub-heading-blue-700-16">
                        {{peopleInfo.displayName}}
                    </div>
                    <div>
                        <span style="padding-right: 5px;">
                            <img src="assets/icons/user-mail.png" alt="img">
                        </span>
                        <span class="dialog-content-blue-500">{{peopleInfo.mail}}</span>
                    </div>
                    <div>
                        <span style="padding: 0 8px 0 2px">
                            <img src="assets/icons/user-mobile.png" alt="img">
                        </span>
                        <span class="dialog-content-blue-500">{{peopleInfo.mobile}}</span>
                    </div>
                    <div>
                        <span style="padding: 0 8px 0 2px">
                            <img src="assets/icons/user-address.png" alt="img">
                        </span>
                        <span class="dialog-content-blue-500">{{peopleInfo.officeLocation | ellipsis: 30}}</span>
                    </div>
                </div>
            </div>
        </div>
    </nb-card>
</div>